export const PORTAL_SERVICOS_ADMIN = "PORTAL_SERVICOS_ADMIN";
export const PORTAL_SERVICOS_GESTOR_ACESSOS = "PORTAL_SERVICOS_GESTOR_ACESSOS";

export const PERMISSAO_VISUALIZAR = "VISUALIZAR";
export const PERMISSAO_EDITAR = "EDITAR";
export const PERMISSAO_PUBLICAR = "PUBLICAR";
export const PERMISSAO_DESPUBLICAR = "DESPUBLICAR";
export const PERMISSAO_RESTAURAR_REVISAO = "RESTAURAR_REVISAO";
export const PERMISSAO_ARQUIVAR = "ARQUIVAR";

export const PERMISSOES_SERVICO = [
  PERMISSAO_VISUALIZAR,
  PERMISSAO_EDITAR,
  PERMISSAO_PUBLICAR,
  PERMISSAO_DESPUBLICAR,
  PERMISSAO_RESTAURAR_REVISAO,
  PERMISSAO_ARQUIVAR
];
